import Vue from "vue";
import Vuex from "vuex";
import moment from "moment";
import { ApiClient } from "./api-client";

Vue.use(Vuex);

// const api = new API("https://technik-socket.m-k.dev/");

const store = new Vuex.Store({
  state: {
    currentUser: "",
    slotList: []
  },
  getters: {
    futureEvents: state => {
      return state.slotList
        .filter(({ date }) => {
          const momentDate = moment(date);
          return moment().isSameOrBefore(momentDate, "day");
        })
        .sort((a, b) => {
          if (a.start > b.start) return 1;
          if (a.start < b.start) return -1;
          return 0;
        });
    },
    slotById: state => slotId => {
      return state.slotList.find(({ id }) => id === slotId);
    },
    username: state => {
      return state.currentUser;
    }
  },
  mutations: {
    setUsername(state, user) {
      state.currentUser = user.name;
    },
    setSlotList(state, slotList) {
      state.slotList = slotList;
    },
    addSlot(state, slot) {
      state.slotList.push(slot);
    },
    removeSlot(state, { slot }) {
      const { id } = slot;
      state.slotList = state.slotList.filter(slot => slot.id !== id);
    },
    addToSlot(state, { user, slot }) {
      const localSlot = state.slotList.find(({ id }) => id === slot.id);
      if (!localSlot.userList) {
        localSlot.userList = [];
      }
      localSlot.userList.push(user.name);
    },
    removeFromSlot(state, { user, slot }) {
      const localSlot = state.slotList.find(({ id }) => id === slot.id);
      if (!localSlot.userList) {
        localSlot.userList = [];
      }
      localSlot.userList = localSlot.userList.filter(
        name => name !== user.name
      );
    }
  },
  actions: {
    login(_, payload) {
      const api = ApiClient.WithTelegramAuth({
        authEndpoint: "/api/auth/",
        payload
      });

      api.fetchSlots().then(res => {
        console.log(res);
      });
    },
    setUserByName(_, name) {
      const user = { name };
      // api.login({ user });
    },
    removeSlot({ state, getters }, slotId) {
      const slot = getters.slotById(slotId);
      if (!slot) return;

      // api.removeSlot({ user: { name: state.currentUser }, slot });
    },
    addSlot({ state }, date) {
      const momentStartDate = moment(date).set("h", 11);
      const momentEndDate = momentStartDate.clone().add(1, "h");
      const slot = {
        start: momentStartDate.format(),
        end: momentEndDate.format(),
        userList: []
      };
      // api.addSlot({ user: { name: state.currentUser }, slot });
    },
    enterSlot({ state, getters }, slotId) {
      const slot = getters.slotById(slotId);
      if (!slot) return;

      // api.enterSlot({ user: { name: state.currentUser }, slot });
    },
    leaveSlot({ state, getters }, slotId) {
      const slot = getters.slotById(slotId);
      if (!slot) return;

      // api.leaveSlot({ user: { name: state.currentUser }, slot });
    },
    init({ commit }, { opportunityList, slotList, user }) {
      const technikOpportunity = opportunityList[0];
      const technikSlotReferenceList = technikOpportunity.slotList;
      const technikSlotList = slotList
        .filter(({ id }) => technikSlotReferenceList.includes(id))
        .map(slot => {
          slot.userList = slot.rawUserList;
          return slot;
        });

      commit("setUsername", user);
      commit("setSlotList", technikSlotList);
    }
  }
});

// api
//   .connect()
//   .on("init", payload => store.dispatch("init", payload))
//   .on("slot::added", ({ slot }) => {
//     slot.userList = slot.rawUserList;
//     store.commit("addSlot", slot);
//   })
//   .on("slot::removed", payload => {
//     store.commit("removeSlot", payload);
//   })
//   .on("slot::entered", payload => {
//     store.commit("addToSlot", payload);
//   })
//   .on("slot::left", payload => {
//     store.commit("removeFromSlot", payload);
//   });

export default store;
